
import ShareButtons from "../../../../utility/ShareButtons";
import QuickNavigation from "../../../../utility/serviceTemplateutility/QuickNavigation";
import MultiStepForm from "../../../../utility/serviceTemplateutility/MultiStepForm";
import CardDesign from "../../../../utility/serviceTemplateutility/CardDesigntwo";
import CheckList from "../../../../utility/serviceTemplateutility/CheckList";
import WhyUs from "../../../../utility/serviceTemplateutility/WhyUs";
import Slider from "react-slick";
import FAQAccordion from "../../../../utility/FAQAccordion";
import OurTeam from "../../../homepage/OurTeam";
import Testimonials from "../../../homepage/Testimonials";
import { useGlobalData } from "../../../../contextApi/globalContextData";
import { useCart } from "../../../../contextApi/cartContext";
export default function OzempicInjections() {
  const serviceUrl = window.location.href;

  const { sectionsData } = useGlobalData();
  const { addToCart } = useCart();

  const product = {
    id: 1,
    title:
      "Ozempic Injection in Dubai - Ozempic for Diabetes &amp; Weight Loss",
    price: 2499,
    description:
      "Ozempic Injection in Dubai helps manage Type 2 diabetes and supports weight loss with a weekly, doctor-prescribed non-surgical treatment.",
  };
  const procedureSteps = [
    { heading: "Easy 4 Steps for Ozempic Procedure" },
    {
      id: 1,
      title: "Initial Evaluation",
      icon: "fa-solid fa-clipboard-check",
      description:
        "Your journey starts with a consultation and health assessment...",
    },
    {
      id: 2,
      title: "Personalized Treatment Plan",
      icon: "fa-solid fa-file-prescription",
      description:
        "We create a tailored treatment plan based on your evaluation...",
    },
    {
      id: 3,
      title: "Injection Process",
      icon: "fa-solid fa-syringe",
      description:
        "Our specialists administer the injection in a quick, minimally uncomfortable procedure...",
    },
    {
      id: 4,
      title: "Follow-Up Appointments",
      icon: "fa-solid fa-calendar-check",
      description:
        "Follow-up visits ensure you're progressing towards your goals...",
    },
  ];

  const benefitChecklist = [
    {
      text: "Weight Loss Support: As a weight loss injection, it aids in weight reduction by reducing appetite and promoting fat metabolism.",
    },
    {
      text: "Effective Blood Sugar Control: Ozempic helps lower HbA1c levels, improving overall blood sugar management.",
    },
    {
      text: "Reduced Risk of Cardiovascular Events: Ozempic has been shown to lower the risk of heart-related complications in individuals with Type 2 diabetes.",
    },
    {
      text: "Convenient Weekly Dosing: The injection is administered once a week, offering ease of use compared to daily medications.",
    },
    {
      text: "Improved Insulin Sensitivity: It enhances the body's ability to respond to insulin, helping maintain stable blood glucose levels.",
    },
  ];
  const eligibilityList = [
    {
      text: "Adults with Type 2 Diabetes: Particularly those who haven't achieved blood sugar control with other medications or lifestyle changes.",
    },
    {
      text: "Overweight or Obese Individuals: People who are overweight and have diabetes may benefit from Ozempic Injection.",
    },
    {
      text: "Cardiovascular Risk: Those with a high risk of cardiovascular disease has shown cardiovascular benefits.",
    },
    {
      text: "Patients Seeking a Simple Regimen: Those who prefer a once-weekly medication for its convenience and ease of use.",
    },
  ];

  const results = [
    {
      id: 1,
      src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/113.webp",
      alt: "Ozempic Weight Loss Injection",
    },
    {
      id: 2,
      src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/105.webp",
      alt: "Ozempic Injection in dubai",
    },
    {
      id: 3,
      src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/weight-loss-2-1.jpg",
      alt: "Ozempic in dubai",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const faqs = [
    { heading: "Frequently Asked Questions" },
    {
      question: "Can I get Ozempic in the UAE?",
      answer:
        "Yes, Ozempic is available in the UAE through licensed medical professionals and clinics specializing in diabetes and weight management treatments.",
    },
    {
      question: "Can you get Ozempic over the counter?",
      answer:
        "No, Ozempic requires a prescription from a licensed healthcare provider in order to ensure it's suitable for your health condition.",
    },
    {
      question: "Can I take Ozempic without seeing a doctor?",
      answer:
        "No, you must consult a doctor before using Ozempic to ensure it is safe and effective for managing your diabetes or weight loss goals.",
    },
    {
      question: "How quickly does Ozempic start working?",
      answer:
        "Ozempic starts working within a few days, with noticeable improvements in blood sugar levels and appetite control after a few weeks of regular use.",
    },
    {
      question: "Are there any side effects for Ozempic Injections?",
      answer:
        "Some people may experience mild side effects such as nausea, diarrhea, or headaches. Consult a doctor if side effects persist or worsen.",
    },
    {
      question: "Is Ozempic safe during pregnancy or breastfeeding?",
      answer:
        "Ozempic is not recommended during pregnancy or breastfeeding. Always consult your doctor to evaluate risks and alternative treatments.",
    },
    {
      question: "What is the Price of Ozempic Injection in Dubai?",
      answer:
        "The price of Ozempic in Dubai varies depending on the clinic and treatment plan. A consultation will provide detailed pricing tailored to your needs.",
    },
    {
      question: "Are Ozempic and Mounjaro the same medication?",
      answer:
        "No, Ozempic and Mounjaro are different medications. Both treat Type 2 diabetes but have distinct ingredients and mechanisms of action.",
    },
  ];
  const quickFacts = [
    { text: "Cost: Prices start between AED 2,100 to AED 3,150" },
    { text: "Target: Type 2 diabetes & Weight Loss." },
    { text: "Gender: Both male and female" },
    { text: "Type of Procedure: Injectable" },
    { text: "Dosage: 0.25 mg once a week or as prescribed." },
    {
      text: "Duration of Treatment: Continuing - as prescribed by the doctors.",
    },
    {
      text: "Results: Effectively lowers HbA1c levels, resulting in improved blood sugar control.",
    },
  ];

  return (
    <>
      <title>
        Ozempic Injection in Dubai - Ozempic for Diabetes &amp; Weight Loss
      </title>
      <meta
        name="description"
        content="Ozempic Dubai â€“ Get FDA-approved Ozempic injections for Type 2 diabetes and weight loss. Available at Elite Body Home with a free consultation. Book Now."
      />
      <meta
        name="robots"
        content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
      />
      <link
        rel="canonical"
        href="https://elitebodyhome.com/services/services/ozempic-injection/"
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content="Ozempic Injection in Dubai - Ozempic for Diabetes &amp; Weight Loss"
      />
      <meta
        property="og:description"
        content="Ozempic Dubai â€“ Get FDA-approved Ozempic injections for Type 2 diabetes and weight loss. Available at Elite Body Home with a free consultation. Book Now."
      />
      <meta
        property="og:url"
        content="https://elitebodyhome.com/services/ozempic-injection/"
      />
      <meta property="og:site_name" content="elitebodyhome.com" />
      <meta property="og:updated_time" content="2025-02-19T08:40:44+00:00" />
      <meta
        property="og:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-107.jpg"
      />
      <meta
        property="og:image:secure_url"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-107.jpg"
      />
      <meta property="og:image:width" content="1254" />
      <meta property="og:image:height" content="700" />
      <meta property="og:image:alt" content="Ozempic Injection in Dubai" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Ozempic Injection in Dubai - Ozempic for Diabetes &amp; Weight Loss"
      />
      <meta
        name="twitter:description"
        content="Ozempic Dubai â€“ Get FDA-approved Ozempic injections for Type 2 diabetes and weight loss. Available at Elite Body Home with a free consultation. Book Now."
      />
      <meta
        name="twitter:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-107.jpg"
      />
      <div className="min-vh-100 font-sans text-dark mb-5 mx-3">
        <div className="container-fluid px-0 py-4">
          <div className="row justify-content-center">
            <div >
              <div
                className=" rounded-4 overflow-hidden shadow-sm"
                style={{  border: "2px solid #c69933",}}
              >
                <div className="row g-0 align-items-stretch">
                  {/* Image Column - Left Side */}
                  <div className="col-lg-6">
                    <img
                      loading="lazy"
                      decoding="async"
                      src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Ozempic-Header-large.png"
                      className="img-fluid w-100 h-100 object-fit-cover"
                      alt="Aqualyx fat dissolving injections in Dubai | Elite Body Home"
                      style={{
                        minHeight: "400px",
                        maxHeight: "720px",
                      }}
                    />
                  </div>

                  {/* Content Column - Right Side */}
                  <div className="col-lg-6 d-flex align-items-center bg-white">
                    <div
                      className="p-4 p-md-5 w-100"
                      style={{ maxWidth: "600px", margin: "0 auto" }}
                    >
                      <h1
                        className="display-5 fw-bold mb-3"
                        style={{
                          color: "#c69933",
                        }}
                      >
                        Ozempic Injection in Dubai
                      </h1>
                      <p className="fs-5 text-secondary mb-4">
                        <ul>
                          <li>
                            Approved by the U.S. Food and Drug Administration
                            (FDA)
                          </li>
                          <li>Ozempic for Type 2 Diabetes &amp; Weight Loss</li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex gap-4  w-100 ">
          <div
            className=" rounded-4 p-2 bg-white flex-grow-1 "
            style={{
              width: "65%",
              border: "2px solid #c69933",
            }}
          >
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/home">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Services
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Ozempic Injection in Dubai
                </li>
              </ol>
            </nav>
            <QuickNavigation />
            <div>
              <p>
                Struggling with weight management or type 2 diabetes? Ozempic
                Injection in Dubai at Elite Body Home Polyclinic offers a
                proven, doctor-recommended solution to help you achieve real
                results.
              </p>
              <p>
                Our caring medical team provides a thorough health assessment
                and personalized support to ensure your journey is safe and
                effective. Whether you&#8217;re looking to lose weight or
                improve your overall health, Ozempic can make a lasting
                difference.
              </p>
            </div>
            <div>
              <CheckList
                title="Ozempic Dubai – Quick Facts"
                items={quickFacts}
              />
            </div>
            <div className="container my-5">
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  {/* Heading */}
                  <h2 className="text-center mb-4">
                    What is Ozempic Injection?
                  </h2>

                  {/* Image */}
                  <div className="text-center mb-4">
                    <img
                      src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Ozempic-Injection-Dubai-large.png"
                      alt="Ozempic Injection"
                      className="img-fluid rounded"
                      style={{ maxHeight: "400px" }}
                    />
                  </div>

                  {/* Text Content */}
                  <div className="px-3">
                    <p className="mb-3">
                      Ozempic is an FDA-approved prescription medication
                      containing semaglutide, designed to help manage blood
                      sugar levels in adults with type 2 diabetes.
                    </p>
                    <p>
                      It works by stimulating insulin release, slowing
                      digestion, and reducing appetite, which can also support
                      effective weight loss.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div>
                <h2 className="title">
                  How Ozempic Helps Control Type 2 Diabetes
                </h2>
              </div>
              <div>
                <p>
                  Ozempic helps treat type 2 diabetes by mimicking the action of
                  a hormone called GLP-1, which regulates blood sugar levels. It
                  stimulates the pancreas to release insulin when blood sugar is
                  high, slows down digestion to prevent spikes, and reduces
                  appetite. Together, these effects help lower blood sugar
                  levels and support weight management, improving overall
                  diabetes control.
                </p>
              </div>
            </div>
            <div id="procedures">
              <CardDesign carditems={procedureSteps} />
            </div>
            <div id="benefits">
              <CheckList
                title=" Benefits of Ozempic Injection"
                items={benefitChecklist}
              />
            </div>
            <div id="eligibility">
              <CheckList
                title="Suitable Candidate for This Treatment"
                items={eligibilityList}
              />
            </div>

            <div className="container" id="results">
              <h2 className="title mb-4">Before & After Results</h2>

              <div className="">
                <Slider {...settings}>
                  {results.map((result) => (
                    <div key={result.id} className="px-2">
                      <div className="card border-0">
                        <img
                          src={result.src}
                          alt={result.alt}
                          className="img-fluid rounded"
                          style={{ height: "auto", objectFit: "cover" }}
                        />
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
            <div className="container my-4">
              <div
                className="card border-0 shadow-sm rounded-3 overflow-hidden"
                style={{ maxWidth: "380px", margin: "auto" }}
                itemScope
              >
                {/* Optimized Image */}
                <img
                  src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Bannwar-large.png"
                  alt="Mounjaro Injection in Dubai"
                  className="card-img-top"
                  style={{ height: "220px", objectFit: "cover" }}
                  itemProp="image"
                  loading="lazy"
                />

                <div className="card-body px-3 py-3 text-center">
                  {/* Product Title */}
                  <h2
                    className="h5 fw-bold mb-2 text-dark"
                    itemProp="name"
                    style={{ lineHeight: "1.3" }}
                  >
                    Ozempic Injection in Dubai - Ozempic for Diabetes &amp;
                    Weight Loss
                  </h2>

                  {/* Compact Description */}
                  <p
                    className="text-muted small mb-3"
                    itemProp="description"
                    style={{ fontSize: "0.85rem" }}
                  >
                    Ozempic Injection in Dubai helps manage Type 2 diabetes and
                    supports weight loss with a weekly, doctor-prescribed
                    non-surgical treatment.
                  </p>

                  {/* Price Section */}
                  <div className="mb-3" itemProp="offers" itemScope>
                    <span
                      className="text-success fw-bold"
                      style={{ fontSize: "1.05rem" }}
                    >
                      {/* <span itemProp="price">AED 2499</span> */}
                      <meta itemProp="priceCurrency" content="AED" />
                    </span>
                  </div>

                  {/* CTA Button */}
                  <button
                    className="btn rounded-pill px-3 py-1 text-white"
                    style={{
                      backgroundColor: "#c69933",
                      border: "2px solid #c69933",
                      fontSize: "0.9rem",
                    }}
                    onClick={() => addToCart(product)}
                    aria-label="Book Ozempic Injections"
                  >
                    Add to Cart
                  </button>
                </div>

                {/* Hidden SEO Data */}
                <meta itemProp="brand" content="Elite Body Home" />
                <meta itemProp="sku" content="AQX-001" />
              </div>
            </div>
            <div className="mt-5">
              <WhyUs language="en" />
            </div>
            <OurTeam data={sectionsData["Professional"]} />
            <Testimonials data={sectionsData["Success Stories"]} />
            <FAQAccordion faqData={faqs} />
            <ShareButtons url={serviceUrl} />
          </div>
          <MultiStepForm />
        </div>
      </div>
    </>
  );
}
